import { render, staticRenderFns } from "./FiliaisMapeadas.vue?vue&type=template&id=66d6edb6&scoped=true"
import script from "./FiliaisMapeadas.vue?vue&type=script&lang=js"
export * from "./FiliaisMapeadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d6edb6",
  null
  
)

export default component.exports